
import React from 'react';
import { GoogleIcon, CsvIcon, DatabaseIcon } from './Icons';

export const SourceBadge = ({ source }: { source?: string }) => {
  if (source === 'google') {
    return <span className="flex items-center gap-1 text-[10px] bg-slate-50 text-slate-500 px-1.5 py-0.5 rounded border border-slate-100"><GoogleIcon /> Google</span>;
  }
  if (source === 'csv') {
    return <span className="flex items-center gap-1 text-[10px] bg-indigo-50 text-indigo-600 px-1.5 py-0.5 rounded border border-indigo-100"><CsvIcon /> CSV Upload</span>;
  }
  return <span className="flex items-center gap-1 text-[10px] bg-slate-100 text-slate-500 px-1.5 py-0.5 rounded border border-slate-200"><DatabaseIcon /> Database</span>;
};
    